import { Routes, Route, Outlet } from 'react-router-dom'
import AppShell from '../components/AppShell'
import LandingHeader from '../components/LandingHeader'
import ProtectedRoute from '../components/ProtectedRoute'
import Home from '../pages/Home'
import Login from '../pages/Login'
import Signup from '../pages/Signup'
import Dashboard from '../pages/Dashboard'
import InvoiceNew from '../pages/InvoiceNew'
import InvoiceDetail from '../pages/InvoiceDetail'
import Settings from '../pages/Settings'

function LandingLayout() {
  return (
    <div className="min-h-screen bg-ica-bg text-ica-text">
      <LandingHeader />
      <main className="mx-auto max-w-6xl px-4">
        <Outlet />
      </main>
    </div>
  )
}

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<LandingLayout />}>
        <Route path="/" element={<Home />} />
      </Route>

      <Route path="/sign-in/*" element={<Login />} />
      <Route path="/sign-up/*" element={<Signup />} />

      <Route element={<AppShell />}>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices/new"
          element={
            <ProtectedRoute>
              <InvoiceNew />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices/:id"
          element={
            <ProtectedRoute>
              <InvoiceDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  )
}
